import { useEffect } from 'react';
import { useProject } from '@atlassian/jira-business-entity-project-hook/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook } from '@atlassian/react-sweet-state';
import { localStorage } from '../../common/utils/storage.tsx';

export const STORAGE_KEY = 'column.widths';

type State = {
	storageKey: string | null;
	columnsWidths: {
		[key: string]: number;
	};
};

const actions = {
	setColumnWidth:
		(columnKey: string, width: number) =>
		({ setState, getState }: { setState: (arg1: State) => void; getState: () => State }) => {
			const state = getState();
			const { columnsWidths, storageKey } = state;
			if (storageKey == null) {
				return;
			}

			const newState = {
				...state,
				columnsWidths: { ...columnsWidths, [columnKey]: width },
			};
			localStorage.set(storageKey, newState.columnsWidths);
			setState(newState);
		},

	initState:
		(projectKey: string) =>
		({ setState, getState }: { setState: (arg1: State) => void; getState: () => State }) => {
			const state = getState();
			if (state.storageKey != null) {
				return;
			}
			const storageKey = `${projectKey}-${STORAGE_KEY}`;
			setState({
				...state,
				storageKey,
				columnsWidths: localStorage.get(storageKey) || {},
			});
		},
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	initialState: { storageKey: null, columnsWidths: {} },
	actions,
	name: 'JBusListViewColumnWidthStore',
});

const useHook = createHook(Store);

export const useColumnWidths = () => {
	const [{ columnsWidths }, { setColumnWidth, initState }] = useHook();
	const projectData = useProject();
	const projectKey = projectData.key;

	useEffect(() => {
		if (projectKey != null) {
			initState(projectKey);
		}
	}, [initState, projectKey]);

	return [columnsWidths, { setColumnWidth }] as const;
};
